module.exports = __webpack_public_path__ + "static/img/khal_02.e3aae99.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/khal_02.png
// module id = Stc5
// module chunks = 2